// ============================================================================
// FSA DEPRECIATION CALCULATION ENDPOINTS  (ADR-0006)
// ============================================================================
// BASE_PATH matches FsaDepreciationCalcsController ([Route("api/v1/[controller]")]).

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaDepreciationCalcs';

export const fsaDepreciationCalcEndpoints = {
  /** GET /api/v1/FsaDepreciationCalcs/by-engagement/{engId} — workspace (get-or-create) */
  workspace: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** PUT /api/v1/FsaDepreciationCalcs/by-engagement/{engId} — save full workspace */
  save: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** GET /api/v1/FsaDepreciationCalcs/by-engagement/{engId}/pdf — working-paper PDF */
  pdf: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/pdf`, { engId }),

  /** GET /api/v1/FsaDepreciationCalcs/by-engagement/{engId}/excel — working-paper Excel */
  excel: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/excel`, { engId }),

  /** GET /api/v1/FsaDepreciationCalcs/by-engagement/{engId}/suggestions/{scheduleId} — note movement suggestions (1b) */
  suggestions: (engId: ID, scheduleId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/suggestions/:scheduleId`, { engId, scheduleId }),

  /** GET /api/v1/FsaDepreciationCalcs/by-engagement/{engId}/dt-suggestion — deferred tax suggestion (1b) */
  dtSuggestion: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/dt-suggestion`, { engId }),
} as const;

export default fsaDepreciationCalcEndpoints;
